import { Injectable } from '@angular/core';
import { RepositoryService } from '@wephone-core/service/repository_service';

@Injectable()
export class PhoneRepositoryService extends RepositoryService {
    getRepositoryList(): any[] {
        const repoList = super.getRepositoryList();

        const excludedList = [
            'QualificationRepository'
        ];

        for (const e of excludedList) {
            const found = repoList.find(x => x[1] === e);
            if (found) {
                // console.log('found excluded', found);
                repoList.splice(repoList.indexOf(found), 1);
            }
        }

        // console.log('repoList', repoList);
        return repoList;
    }
}
